<script>
    /*
    	ReferralInfo.svelte

        This area will not show if on the final SuccessScreen
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
	import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiMapMarkerOutline, mdiBookmarkOutline, mdiInformationOutline, mdiWeb } from '@mdi/js';

    const SVG_HUG_PATH = '/img/illustration_hug.png';
    const INVALID_URL_MEG = 'Invalid url: ';

    export let serviceData;
    export let showDetails;
    export let isReferralSubmitted;

    onMount(() => {
    })

    const visitWebSite = () => {
        let href = serviceData.mainWebsite;
        if (!href || href.length < 3) return;
        let prefix = href.substring(0, 3);
        if (prefix === 'www') {
            href = '//' + href;         // avoid localhost:
        } else {
            href = '//www.' + href;     // avoid localhost:
        }
        window.open(href, "_blank") || window.location.replace(href);
    }


</script>

<style>
    .referral-info {
        position: relative;
        left: 10%;
        width: 75%;
        min-height: 175px;
        padding: 30px 15px 0px 40px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        background-color: var(--tcui-ruby-light);
        border-radius: 30px;
    }

    .referral-info .left {
        width: 80%;
        /* border: 2px solid green; */
    }

    .referral-info .name {
        min-height: 22px;
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;        
        color: var(--tcui-secondary);
    }
    
    .referral-info .descr {
        min-height: 90px;
        font-size: 12px;
        line-height: 16px;
        color: var(--tcui-primary);
    }
    
    .info-icons {
        margin-left: -15px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 15px;
        /* border: 1px solid red; */
    }

    .info-icons .icon-block {
        user-select: none;
        width: 60px;
        height: 45px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        font-size: 11px;
        color: var(--tcui-secondary);
        /* border: 1px solid green; */
    }

    .info-icons .icon-block:hover {
        color: var(--tcui-primary);
    }

    /* child CSS child element */
    :global(.info-icons .icon-block:hover > svg) {
        fill: var(--tcui-primary);
    }

    :global(.info-icons svg) {
        width: 30px;
        height: 30px;
        fill: var(--tcui-secondary);
        outline: none;
        /* border: 1px solid blue; */
    }

    .referral-info .right {
        width: 20%;
        /* border: 2px solid blue; */
    }

    .referral-info img {
        margin-top: 20px;
        margin-left: 10px;
        /* border: 1px solid green; */
    }

    /* web button - override for this page */
    :global(.info-icons  .service-web-button) {
        color: var(--tcui-secondary);
    }

    :global(.info-icons  .service-web-button svg) {
        width: 30px !important;
        height: 30px !important;
        fill: var(--tcui-secondary);
        outline: none;
    }

    :global(.info-icons .service-web-button svg:hover) {
        fill: var(--tcare-primary);
    }



    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- hide this box if on the SuccessPage -->
{#if !isReferralSubmitted}

    <div class="referral-info">
        {#if serviceData}

        <div class="flex-block left">

            <div class="name">{serviceData['service-name']}</div>
            <div class="spacer-h-10"></div>

            {#if serviceData.description && serviceData.description.length > 3}
                <div class="descr">{serviceData.description}</div>
            {/if}

            <div class="spacer-h-10"></div>

            <div class="info-icons">
                <div class="icon-block">
                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiMapMarkerOutline} /></Icon>
                    <div>2.8 mi</div>
                </div>

                <!--
                <div class="icon-block">
                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiBookmarkOutline} /></Icon>
                    <div>Bookmark</div>
                </div>
                -->
                
<!--                <div class="icon-block" on:click={() => showDetails(true)}>-->
<!--                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiInformationOutline} /></Icon>-->
<!--                    <div>Info</div>-->
<!--                </div>-->

                {#if serviceData.mainWebsite && serviceData.mainWebsite.length > 2}
                    <div class="icon-block" on:click={() => visitWebSite()}>
                        <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiWeb} /></Icon>
                        <div>View Site</div>
                    </div>
                {/if}
            </div>
        </div>

        <div class="flex-block right">
            <img src={SVG_HUG_PATH} alt={'Hugging'} >
        </div>

        {/if}
    </div>
{/if}
